import React from 'react';
export function rankingBgColor(rank){
    if(rank === 1){
        return "#D6BA49"
    } else if(rank === 2){
        return "#858585"
    } else if(rank === 3){
        return "#C8A17E"
    } else {
        return "#000000"
    }
}
export function rankingOpacity(rank){
    if(rank === 1){
        return "1"
    } else if(rank === 2){
        return "1"
    } else if(rank === 3){
        return "1"
    } else {
        return "0.7"
    }
}